import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuditService, AuditLog } from '../../services/audit.service';

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.css']
})
export class AuditLogsComponent implements OnInit, OnDestroy {

  loading = true;
  private sub = new Subscription();

  allLogs: AuditLog[] = [];
  filtered: AuditLog[] = [];

  // filters
  search = '';
  actionFilter = '';
  entityFilter = '';

  entityTypes: string[] = [];
  readonly actions = ['create', 'update', 'delete'];

  expanded: { [id: string]: boolean } = {};

  constructor(private audit: AuditService) {}

  ngOnInit(): void {
    this.sub.add(
      this.audit.getAuditLogs$(500).subscribe(logs => {
        this.allLogs = logs;
        this.entityTypes = Array.from(new Set(logs.map(l => l.entityType))).sort();
        this.applyFilters();
        this.loading = false;
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  applyFilters(): void {
    const term = this.search.trim().toLowerCase();
    this.filtered = this.allLogs.filter(log => {
      if (this.actionFilter && log.action !== this.actionFilter) return false;
      if (this.entityFilter && log.entityType !== this.entityFilter) return false;
      if (term) {
        const haystack = [
          log.performedBy,
          log.entityType,
          log.entityId,
          log.reason,
          (log.changedFields || []).join(' ')
        ].join(' ').toLowerCase();
        if (!haystack.includes(term)) return false;
      }
      return true;
    });
  }

  toggle(id: string): void {
    this.expanded[id] = !this.expanded[id];
  }

  clearFilters(): void {
    this.search = '';
    this.actionFilter = '';
    this.entityFilter = '';
    this.applyFilters();
  }

  formatDate(createdAt: number): string {
    if (!createdAt) return '';
    return new Date(createdAt).toLocaleString();
  }

  actionColor(action: string): string {
    switch (action) {
      case 'delete': return 'delete';
      case 'create': return 'create';
      case 'update': return 'update';
      default: return '';
    }
  }

  pretty(value: any): string {
    if (value === null || value === undefined) return '—';
    try {
      return JSON.stringify(value, null, 2);
    } catch (e) {
      return String(value);
    }
  }
}
